import React from 'react';
import css from './css';
import { connect } from '~/redux/connect';
import { getResultsValue, getSelectedRows, getSelectThroughout } from '../../stateGetter';

import {TextField} from '~/native-ui';

const mapStateToProps = (state, { modelId, threshold }) => {
    const selections = getSelectedRows(state, modelId),
          totalRowsCount = getResultsValue(state, modelId).total,
          selectionCount = (getSelectThroughout(state, modelId) ? totalRowsCount - selections.length : (selections.length || totalRowsCount) );
    return {
        showCriticalConfirm: threshold <= selectionCount,
    }
}

export const ConfirmField = connect(mapStateToProps)((props) => {
    const { trans, valueToConfirm, showCriticalConfirm, onChange } = props;
    const [confirmValue, setConfirmValue] = React.useState("");
    const [isMatch, setIsMatched] = React.useState(false);
    const rows = React.useRef([{ name: "confirm" }]).current;


    React.useEffect(() => {
        onChange(!showCriticalConfirm || isMatch);
    }, [showCriticalConfirm, isMatch]);


    const onChangeConfirmField = React.useCallback((val) => {
        setConfirmValue(val);
        setIsMatched(valueToConfirm === val);
    }, [setConfirmValue, setIsMatched, valueToConfirm]);

    if (!showCriticalConfirm) {
        return null;
    }
    
    const inputProps = {
        onChange: onChangeConfirmField,
        title: trans("confirmAction.criticalConfirm", { confirmText: valueToConfirm }),
        value: confirmValue,
        editable: true,
    }


    return (
        <TextField { ...inputProps } className={css.confirmField} />
    )
})